import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import { routesAdmin } from '../../routes/Routes';
import { InputNumber } from 'antd';
import _notification from 'modules/notification';
import { Card, Table, Modal, Radio, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import StatusBadge from 'components/enterprise/StatusBadge';
import ButtonComponent from 'components/controls/Button';
import InputCheck from 'components/controls/InputCheck';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import ImageToBase64 from '../../components/controls/ImageToBase64';
import CKEditorComponent from '../../components/controls/CKEditorComponent';


class PostMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 8, current: 1 },
            highlightedRowID: 0,
            data: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            showConformBox: false,
            postError: "",
            logo1: "",
            MinAgeError: "",
            MaxAgeError: "",
            WorkExperienceError: "",
            GSTError: ""
        };
    }

    componentDidMount() {
        this.getAllPosts();
    }

    //API operations
    getAllPosts = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let postList = await _AdminService.GetAllPost();
                    //console.log("postList Data: ", postList.data);

                    this.setState({
                        ...this.state,
                        data: postList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    
    
    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            Name: this.state.rowData.Name.trim(),
            Id: this.state.rowData.Id,
            IsAllowExamCardDownload: this.state.rowData.IsAllowExamCardDownload,
            IsExamPaymentOnline: this.state.rowData.IsExamPaymentOnline,
            //PostImage: this.state.rowData.IsExamPaymentOnline ? this.state.rowData.PostImage : null,
            PostImage: this.state.rowData.PostImage,
            AllowCandidateRegistration: this.state.rowData.AllowCandidateRegistration,
            IsAadharMandetory: this.state.rowData.IsAadharMandetory,
            //IsAadharMandetory: true,
            IsAgeRelaxationMandetory: this.state.rowData.IsAgeRelaxationMandetory,
            IsCategoryMandatory: this.state.rowData.IsCategoryMandatory,
            IsDrivingLicenceMandatory: this.state.rowData.IsDrivingLicenceMandatory,
            MaxAge: this.state.rowData.MaxAge,
            MinAge: this.state.rowData.MinAge,
            YearInExperience:this.state.rowData.YearInExperience,
            Vacancy: this.state.rowData.Vacancy,
            GST: this.state.rowData.GST,
            ShowExServiceMan: this.state.rowData.ShowExServiceMan,
            ShowHandicap: this.state.rowData.ShowHandicap,
            ShowMahila: this.state.rowData.ShowMahila,
            InterviewLetterNote:this.state.rowData.InterviewLetterNote ? this.state.rowData.InterviewLetterNote : "",
            AppointmentLetterNote: this.state.rowData.AppointmentLetterNote ? this.state.rowData.AppointmentLetterNote : ""
        }

        //console.log("Final data: ", params);
        if (this.state.rowData.Name && this.state.rowData.Name !== "") {
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        const response = await _AdminService.CreatePost(params);
                        //console.log("Post response: ", response);
                        if (response.status == 200) {
                            _notification.showMessage('success', "Post saved successfully.");
                            this.setState({
                                post: "",
                                postError: "",
                                logo1: "",
                                showModel: false,
                                loading: false,
                                highlightedRowID: response.data.Id,
                                showConformBox: params.Id ? false : true

                            });
                            this.getAllPosts();
                        }
                        else {
                            _notification.showMessage('error', response.data.message);
                        }
                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    }
                });
            } catch (e) { }
        } else {

        }
    }

    deletePost = async (value) => {
        const params = {
            Name: this.state.rowData.Name.trim(),
            Id: this.state.rowData.Id
        }

        //console.log("Final data: ", params);
        try {
            const response = await _AdminService.DeletePost(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Post deleted successfully.");
                this.setState({
                    post: "",
                    postError: "",
                    logo1: "",
                    showModel: false
                });
                this.getAllPosts();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }

    }

    //Table action link clicks
    onEditClick = (value) => {
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 }, () => {
            window.scrollTo(0, 0);
        });
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination, filters, sorter, extra);
        this.setState({ pagination: pagination, highlightedRowID: 0 });
    }

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    onConfirmShow = (value) => {
        this.setState({ showConformBox: false });
        if (value) {
            console.log("Navigated");
            this.props.history.push(routesAdmin.postconfiguration.basePath + '/' + this.state.highlightedRowID)
        }
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    closeConfirmBox(value = false) {
        this.setState({ showConformBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: { IsExamPaymentOnline: false, MinAge: 18, MaxAge: 30 } });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {}, postError: '' });
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Name' && value.length > 50)
            return;

        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, Id: this.state.rowData.Id, [name]: value }
        });
    }

    onChangExamCardDownload = e => {
        //console.log(e.target.name, ' = ', !this.state.rowData.IsAllowExamCardDownload);
        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, [e.target.name]: !this.state.rowData.IsAllowExamCardDownload }
        });
    };

    onChangAllowCandidateRegistration = e => {
        //console.log(e.target.name, ' = ', !this.state.rowData.IsAllowExamCardDownload);
        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, [e.target.name]: !this.state.rowData.AllowCandidateRegistration }
        });
    };

    onPaymentModeChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, IsExamPaymentOnline: !this.state.rowData.IsExamPaymentOnline }
        });
    }

    onLogoOneSelect = (data) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, ["PostImage"]: data }
        });
    }

    onMinValueChange = (value) => {
        if (isNaN(value))
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, MinAge: value ? value : 0 }
        });
    };

    onKeyUp = (value) => {
        if (value.key != 'Backspace' && isNaN(value.key))
            value.preventDefault();

    };

    onMaxValueChange = (value) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, MaxAge: value }
        });
    };

    onWorkExperienceValueChange = (value) => {

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, YearInExperience: value ? value : 0}
        });
    };

    // Primary Result Automation & Interview Shortlisting phase: persistent per-post Vacancy count,
    // the authoritative input for the Interview Shortlist (Vacancy x Interview Ratio) computation.
    onVacancyValueChange = (value) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Vacancy: value ? value : null }
        });
    };

    onGSTValueChange = (value) => {
        let GSTError = "";
        if(value === ""){
            GSTError = "Please enter GST"
        }
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, GST: value, GSTError:GSTError }
        });
    };

    onConfigCheck = event => {
        //console.log(event.target.name, " ", !this.state.rowData[event.target.name]);        
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: !this.state.rowData[event.target.name] }
        });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            postError: '',
            MinAgeError: "",
            MaxAgeError: "",
            WorkExperienceError: "",
            GSTError: ""
        });

        let hasError = false;

        if (!body.Name || !body.Name.trim()) {
            this.setState({ postError: 'Please enter valid Post/Exam Name' });
            hasError = true
        }

        //if (body.IsExamPaymentOnline && !body.PostImage) {
        if (!body.PostImage) {
            this.setState({ logo1: 'Please select Post Image' });
            hasError = true
        }

        if (!body.MinAge) {
            this.setState({ MinAgeError: 'Please enter valid Min Age' });
            hasError = true
        }

        if (!body.MaxAge) {
            this.setState({ MaxAgeError: 'Please enter valid Max Age' });
            hasError = true
        }

        if (body.MinAge && body.MaxAge) {
            if (body.MinAge >= body.MaxAge) {
                this.setState({ MinAgeError: 'Minimum Age should be less than Maximum Age.', MaxAgeError: 'Minimum Age should be less than Maximum Age.' });
                _notification.showMessage('error', "Minimum Age should be less than Maximum Age.");
                hasError = true
            }
        }

        if(!body.GST){
            this.setState({ GSTError: 'Please enter GST' });
            _notification.showMessage('error', "Please enter GST.");
            hasError = true
        }

        // if(body.YearInExperience){
        //     this.setState({ WorkExperienceError: 'Please enter valid WorkExperience' });
        //     _notification.showMessage('error', "Please enter valid WorkExperience.");
        //     hasError = true
        // }
        
        return hasError;
    }

    handleInterviewLetterNote = (stateName, model) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [stateName]: model }
        });
    }

    render() {
        const TableColumns = [
            {
                title: (value) => { return <p className="tableth font-weight-bold mb-0">Post/Exam Name</p> },
                dataIndex: 'Name',
                filterSearch: true,
                width: '20%',
                key: 'Name',
                // Table Layout Consistency phase (28 Aug 2026): `ellipsis: true` forces this column's
                // cell to single-line truncate (antd auto-applies white-space:nowrap/overflow:hidden/
                // text-overflow:ellipsis, matching the .ent-post-wise-card / .ent-stat-card-label fixes
                // already applied elsewhere) AND supplies a native `title` tooltip with the full value —
                // needed here since some Post names ("Law Officer (Banking Officer Gr2)new") are long
                // enough to otherwise force the row taller and squeeze every other column.
                ellipsis: true,
                sorter: (a, b) => a.Name.length - b.Name.length,
            },
            {
                title: (value) => { return <p className="tableth font-weight-bold mb-0">Allow<br />Registration</p> },
                dataIndex: 'AllowCandidateRegistration',
                filterSearch: true,
                width: '12%',
                key: 'AllowCandidateRegistration',
                render: (value, row) => <StatusBadge status={value ? "Yes" : "No"} tone={value ? "success" : "neutral"} />
            },
            {
                title: (value) => { return <p className="tableth font-weight-bold mb-0">Payment <br />Mode</p> },
                dataIndex: 'IsExamPaymentOnline',
                filterSearch: false,
                // Table Layout Consistency phase: this was 5% — nowhere near enough room for "ONLINE"
                // (the StatusBadge's own text-transform:uppercase makes it wider than the source
                // "Online" string), which is exactly why it wrapped onto 2-3 lines and stretched the
                // row. Combined with `tableLayout="fixed"` below (which makes these % widths authoritative
                // instead of merely advisory) and the new nowrap/ellipsis safety net in themes.scss.
                width: '12%',
                key: 'IsExamPaymentOnline',
                render: (value, row) => <StatusBadge status={value ? "Online" : "Challan"} tone={value ? "success" : "neutral"} />
            },
            {
                title: (value) => { return <p className="tableth font-weight-bold mb-0">Roll Number <br />Generated</p> },
                dataIndex: "RollNumbersGenerated",
                filterSearch: true,
                width: '13%',
                key: 'RollNumbersGenerated',
                render: (value, row) => <StatusBadge status={value ? "Generated" : "No"} tone={value ? "success" : "neutral"} />
            },
            {
                title: (value) => { return <p className="tableth font-weight-bold mb-0">Allow Exam<br />Card Download</p> },
                dataIndex: 'IsAllowExamCardDownload',
                filterSearch: true,
                width: '13%',
                key: 'IsAllowExamCardDownload',
                render: (value, row) => <StatusBadge status={value ? "Allowed" : "No"} tone={value ? "success" : "neutral"} />
            },
            {
                title: (value) => { return (<p className="tableth font-weight-bold mb-0">Hall Ticket<br />Download Count</p>) },
                dataIndex: 'ExamCardDownloadedCount',
                filterSearch: true,
                width: '11%',
                key: 'ExamCardDownloadedCount',
                // Real defect fix: `value ? value : ""` rendered a genuine, correctly-fetched count of
                // 0 as a BLANK cell (0 is falsy in JS) — indistinguishable from the field "not working"
                // at all, which is exactly what was reported. 0 is a perfectly valid count (no
                // candidate has downloaded their Hall Ticket for this Post yet) and should display as
                // such, not disappear.
                render: (value) => (value != null ? value : 0)
            },
            {
                title: (value) => { return <p className="tableth font-weight-bold text-center mb-0">Action</p> },
                dataIndex: '',
                width: '19%',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <PageHeader
                    title="Post/Exam Master"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Post/Exam Master' }]}
                />
                <div className="analysisWrap">

                    <div style={{ textAlign: 'right' }}>
                        {!this.state.showModel &&
                            <div className="max1200 m-auto mb-2"> 
                                <div className="d-flex align-items-center justify-content-end">
                                    <a className="button-global button-border addbutton   d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center" onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Post/Exam</a>
                        
                                </div>
                                
                            </div>
                            
                        }
                    </div>

                    
                    
                            {/* Modal controls */}
                            {this.state.showModel &&
                                <div className="max1200 m-auto">
                                    <div className="ent-panel">
                                        <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Post/Exam </h4>
                                        <div className="admin-inner-wrap p-3">
                                            
                                               
                                                <div className="row flex-sm-row pb-3">
                                                    <div className="mb-2 col-sm-4">
                                                        <MyInput id="post"
                                                            type="text"
                                                            key="post"
                                                            name="Name"
                                                            heading="Post/Exam Name"
                                                            value={this.state.rowData.Name ? this.state.rowData.Name : ""}
                                                            onChange={this.onTextChange}
                                                            isRequired={true}
                                                            errorState={this.state.postError}
                                                            errorMessage={this.state.postError} />
                                                    </div>

                                                    {this.state.rowData.RollNumbersGenerated &&
                                                        <div className="mb-2 col-sm-4">
                                                            <label htmlFor="password">Allow candidates to download Hall Ticket</label>
                                                            <InputCheck
                                                                id="IsAllowExamCardDownload"
                                                                type="checkbox"
                                                                label="Allow Download"
                                                                className="mr-3 mb-0"
                                                                name="IsAllowExamCardDownload"
                                                                value="false"
                                                                onChange={this.onChangExamCardDownload}
                                                                checked={this.state.rowData.IsAllowExamCardDownload}
                                                            />
                                                        </div>}
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="mb-1 col-sm-10">
                                                        <label htmlFor="password">Allow Candidate Registration. (If checked, the post will be displayed in Post DropDown on the registration page.)</label>
                                                        <InputCheck
                                                            id="AllowCandidateRegistration"
                                                            type="checkbox"
                                                            label="Allow Registration"
                                                            className="mr-3 mb-0"
                                                            name="AllowCandidateRegistration"
                                                            value="false"
                                                            onChange={this.onChangAllowCandidateRegistration}
                                                            checked={this.state.rowData.AllowCandidateRegistration}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className=" col-sm-4">
                                                        <label className="card-holder-name mt-4">Payment Mode<span className="color-red">*</span></label>
                                                        <Radio.Group style={{ display: 'flex' }} className="mb-sm-2 mt-sm-2" onChange={this.onPaymentModeChange}
                                                            value={this.state.rowData.IsExamPaymentOnline}>
                                                            <Radio className='ml-2' value={false} style={{ display: 'flex' }}>
                                                                <label className="card-holder-name mr-4">Offline (Bank Challan)</label>
                                                            </Radio>
                                                            <Radio value={true} style={{ display: 'flex' }}>
                                                                <label className="card-holder-name mr-4">Online</label>
                                                            </Radio>
                                                        </Radio.Group>
                                                    </div>
                                                </div>

                                                {/* {this.state.rowData.IsExamPaymentOnline && */}
                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-6">
                                                        <label htmlFor="category">Post Image (This will be displayed on payment checkout page.)<span className="color-red">*</span></label>
                                                        <div >
                                                            <Card className='textAlignCenter uploadCard' style={this.state.logo1 ? { borderColor: 'red', borderWidth: '2px' } : {}}>
                                                                {this.state.rowData.PostImage && <img src={this.state.rowData.PostImage} alt="Logo not set" className='challanLogoStyle' />}
                                                                <ImageToBase64 onSelect={this.onLogoOneSelect} selectText="Select" removeText={this.state.rowData.PostImage ? "Remove" : ""} logoFor="logo1"></ImageToBase64>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* } */}

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="IsAadharMandetory"
                                                            type="checkbox"
                                                            label="Aadhaar Mandatory"
                                                            className="mt-4"
                                                            name="IsAadharMandetory"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.IsAadharMandetory ? this.state.rowData.IsAadharMandetory : false}
                                                        //checked={true}
                                                        //disabled
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Aadhaar Number will become mandatory field at the time of candidate registration. Check this field if only unique candidates to be registered on the portal.</label>
                                                    </div>
                                                </div>
                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="IsAgeRelaxationMandetory"
                                                            type="checkbox"
                                                            label="Show Age Relaxation Fields"
                                                            className="mt-4"
                                                            name="IsAgeRelaxationMandetory"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.IsAgeRelaxationMandetory ? this.state.rowData.IsAgeRelaxationMandetory : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Age and Other relaxation fields like (Ex Serviceman, Ladies, Handicaped, Earth Quake Affected, Player, Anshkalin) will be displayed at the time of candidate registration.</label>
                                                    </div>
                                                </div>
                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="IsCategoryMandatory"
                                                            type="checkbox"
                                                            label="Show Category & Caste Fields"
                                                            className="mt-4"
                                                            name="IsCategoryMandatory"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.IsCategoryMandatory ? this.state.rowData.IsCategoryMandatory : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Category and Caste fields will be displayed and become mandatory at the time of candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="IsDrivingLicenceMandatory"
                                                            type="checkbox"
                                                            label="Driving Licence Mandatory"
                                                            className="mt-4"
                                                            name="IsDrivingLicenceMandatory"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.IsDrivingLicenceMandatory ? this.state.rowData.IsDrivingLicenceMandatory : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Driving Licence will be displayed and become mandatory at the time of candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="ShowExServiceMan"
                                                            type="checkbox"
                                                            label="Show Ex ServiceMan"
                                                            className="mt-4"
                                                            name="ShowExServiceMan"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.ShowExServiceMan ? this.state.rowData.ShowExServiceMan : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Ex ServiceMan will be displayed at the time of candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="ShowHandicap"
                                                            type="checkbox"
                                                            label="Show Handicap"
                                                            className="mt-4"
                                                            name="ShowHandicap"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.ShowHandicap ? this.state.rowData.ShowHandicap : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Handicap will be displayed at the time of candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <InputCheck
                                                            id="ShowMahila"
                                                            type="checkbox"
                                                            label="Show Mahila Reservation"
                                                            className="mt-4"
                                                            name="ShowMahila"
                                                            value="false"
                                                            onChange={this.onConfigCheck}
                                                            checked={this.state.rowData.ShowMahila ? this.state.rowData.ShowMahila : false}
                                                        />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label htmlFor="category">If checked Mahila will be displayed at the time of candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <label htmlFor="category">Minimum Age<span className="color-red">*</span></label>
                                                        <InputNumber className={this.state.MinAgeError ? "border-danger" : ""} min={10} max={32} defaultValue={this.state.rowData.MinAge} onKeyDown={this.onKeyUp} onChange={this.onMinValueChange} />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label className='mt-3' htmlFor="category">Minimum age group allowed for candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <label htmlFor="category">Maximum Age<span className="color-red">*</span></label>
                                                        <InputNumber className={this.state.MaxAgeError ? "border-danger" : ""} min={20} max={50} defaultValue={this.state.rowData.MaxAge} onKeyDown={this.onKeyUp} onChange={this.onMaxValueChange} />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label className='mt-3' htmlFor="category">Maximum age group allowed for candidate registration.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <label htmlFor="category">Work Experience<span className="color-red"></span></label>
                                                        <InputNumber className={this.state.WorkExperienceError ? "border-danger" : ""} defaultValue={this.state.rowData.YearInExperience} onKeyDown={this.onKeyUp} onChange={this.onWorkExperienceValueChange} />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label className='mt-3' htmlFor="category">Applicable Work Experience on examination.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <label htmlFor="category">Vacancy</label>
                                                        <InputNumber min={0} defaultValue={this.state.rowData.Vacancy} onKeyDown={this.onKeyUp} onChange={this.onVacancyValueChange} />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label className='mt-3' htmlFor="category">Number of vacancies for this post — drives the Interview Shortlist and (later) Selected/Waiting calculations.</label>
                                                    </div>
                                                </div>

                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-4 mt-2">
                                                        <label htmlFor="category">GST<span className="color-red">*</span></label>
                                                        <InputNumber className={this.state.GSTError ? "border-danger" : ""} min={0} max={50} step="1" defaultValue={this.state.rowData.GST} onChange={this.onGSTValueChange} />
                                                    </div>
                                                    <div className="col-sm-8 mt-2">
                                                        <label className='mt-3' htmlFor="category">Applicable GST on examination fee charged.</label>
                                                    </div>
                                                </div>                            
                                                
                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-12 mt-2">
                                                        <label className='mt-3' htmlFor="category">Interview Call Letter Format.</label>
                                                    </div>
                                                    <div className="col-sm-12 mt-2">
                                                    <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.InterviewLetterNote}
                                                                modelName="InterviewLetterNote" handleModelChange={this.handleInterviewLetterNote} />
                                                    </div>
                                                </div>
                                                {/* Interview Marks Workflow & Final Result Foundation phase: closes a write-orphan —
                                                    this column already existed on Post and was already read in two candidate-facing
                                                    code paths, but had no admin editor at all until now. Mirrors InterviewLetterNote's
                                                    exact pattern, reusing the same generic handleInterviewLetterNote handler. */}
                                                <div className="row flex-sm-row pl-2 pb-3">
                                                    <div className="col-sm-12 mt-2">
                                                        <label className='mt-3' htmlFor="category">Appointment Letter Format.</label>
                                                    </div>
                                                    <div className="col-sm-12 mt-2">
                                                    <CKEditorComponent placeholderText="Appointment Letter" model={this.state.rowData.AppointmentLetterNote}
                                                                modelName="AppointmentLetterNote" handleModelChange={this.handleInterviewLetterNote} />
                                                    </div>
                                                </div>
                                        </div>
                                        <div className="pt-4 buttonAlignCenter" >
                                            <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                            <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                        </div>
                                    </div>
                                </div>                    
                            }
                        
                    <div className="max1200 m-auto">
                        <Table size='small'
                            bordered
                            rowKey='Id'
                            // Table Layout Consistency phase: without this, each column's `width` is
                            // only an advisory hint to rc-table's auto layout algorithm — actual widths
                            // are computed from cell content, so a narrow column can still be squeezed
                            // below its own text's width by a wider sibling. `fixed` makes the widths
                            // above authoritative.
                            tableLayout="fixed"
                            columns={TableColumns}
                            dataSource={this.state.data}
                            pagination={this.state.pagination}
                            footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                            onChange={this.onTableAction}
                            rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                            className="table-striped-rows admin-table"
                            locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No posts have been added yet." /> }}
                        />
                    </div>
                    

                </div>
                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Post/Exam?"
                    />
                </Modal>
                <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-home"
                    visible={this.state.showConformBox}
                    onCancel={() => this.closeConfirmBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeConfirmBox(false)}
                        onOk={this.onConfirmShow}
                        popupData={this.state.rowData}
                        message="Do you want to set configuration for this Post?"
                    />
                </Modal>

            </div>
        )
    };
}

export default PostMaster